import styled from 'styled-components';

export const Wrapper = styled.div`
    width: 100%;
    border-radius: 10px;
    margin-top: 10px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    background: #0fa457;
`;

export const Text = styled.div`
    color: #ffffff;
    margin: 5px 0;
`;
